<template>
  <div class="animated fadeIn">

    
    <b-card class="card-accent-info" header="Contas de E-mail">
      <b-card-body>

        <b-row>
          <b-col cols="auto" class="mr-auto">
            <!--
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
            -->
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Conta de E-mail</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>
            

        <b-row>

          <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="name">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                <b-form-select id="status"
                  v-model="filters.status"
                  :plain="true"
                  :options="statusddl">
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
      

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              @row-clicked="rowClicked"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped

              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                          <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template #row-details="row">
                  <b-card>
                      <b-row v-show="row.item.summary && row.item.summary.length > 0">
                          <b-col class="small">Resumo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.summary }}</b-col>
                      </b-row>
                      <b-row v-show="row.item.content && row.item.content.length > 0">
                          <b-col class="small">Conteúdo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col>{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                      </b-row>
                  </b-card>
              </template>
              
              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
              </template>
              
              <template v-slot:cell(ispublic)="data">
                  <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>

              <template v-slot:cell(action)="data">
                  <b-button size="sm" variant="primary"  @click="changePasswordModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-lock"></i></b-button>
                  <b-button size="sm" variant="primary"  @click="openTestModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-envelope-o"></i></b-button>
                </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>


   <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Conta de E-mail"
            size="lg">

      <b-card>
        <b-form @submit.stop.prevent="onSubmit">

          <div class="animated fadeIn">
        
            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Servidor de e-mail"
                  label-for="mailserver"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-select id="mailserver"
                      v-model="selectedItem.mailServerId"
                      :plain="true"
                      :options="mailServerDDL"
                      >
                    </b-form-select>
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Conta de E-mail"
                  label-for="name"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>
          
            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="E-mail"
                  label-for="email"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.email" id="email" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Usuário"
                  label-for="username"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.username" id="username" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>
            
            <b-row v-show="!selectedItem.id">
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Senha"
                  label-for="password"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.password" id="password" type="password"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>


            <b-input-group class="mb-4">
                <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
            </b-input-group>
          
          
                
          </div>
        </b-form>

        <div slot="footer" class="text-right">
          <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Conta de E-mail</span></b-button>
        </div>

      </b-card>

    </b-modal>



    <b-modal
        v-model="passwordModal"
        id="password-modal"
        centered
        hide-footer
        title="Alterar Senha"
        size="lg">

        <b-card>

              <b-form @submit.stop.prevent="onSubmit">

                <div class="animated fadeIn">


                    <b-row>
                      <b-col md="12">
                      
                        <b-form>
                          <b-form-group
                          description="Entre com a nova senha"
                          label="Nova senha"
                          label-for="password"
                          :label-cols="3"
                          :horizontal="true">
                          <b-form-input v-model="password" id="password" type="password"></b-form-input>
                        </b-form-group>          
                        </b-form>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="12">
                      
                        <b-form>
                          <b-form-group
                          description=""
                          label="Confirmar senha"
                          label-for="password2"
                          :label-cols="3"
                          :horizontal="true">
                          <b-form-input v-model="password2" id="password2" type="password"></b-form-input>
                        </b-form-group>          
                        </b-form>
                      </b-col>
                    </b-row>

                  <b-input-group class="mb-4">
                          <div class="text-danger" v-if="this.changePasswordErrorMessage && this.changePasswordErrorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.changePasswordErrorMessage }}</div>
                        </b-input-group>


                </div>
                
              
               
            </b-form>

            <div slot="footer" class="text-right">
              <b-button variant="primary" @click="changePassword()"><i class="fa fa-check"></i> Alterar Senha</b-button>
            </div>
          </b-card>

        </b-modal>





        <b-modal
        v-model="testModal"
        id="test-modal"
        centered
        hide-footer
        title="Teste de Envio"
        size="lg">

        <b-card>
          <b-form @submit.stop.prevent="onSubmit">

            <div class="animated fadeIn">


              <b-row>
                <b-col md="12">
                
                  <b-form>
                    <b-form-group
                    description=""
                    label="E-mail destinatário"
                    label-for="recipients"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input v-model="testMail.recipients" id="recipients" type="text"></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                
                  <b-form>
                    <b-form-group
                    description=""
                    label="Assunto"
                    label-for="subject"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input v-model="testMail.subject" id="subject" type="text"></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                
                  <b-form>
                    <b-form-group
                    description=""
                    label="Corpo do e-mail"
                    label-for="bodyText"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-textarea
                        id="bodyText"
                        v-model="testMail.bodyText"
                        placeholder=""
                        rows="3"
                  ></b-form-textarea>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col md="12">
                
                  <b-form>
                    <b-form-group
                    description=""
                    label="Resposta do Servidor"
                    label-for="response"
                    >
                    <b-form-textarea
                        id="response"
                        v-model="testMailResponse"
                        placeholder=""
                        rows="5"
                        readonly
                  ></b-form-textarea>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
                    
              
            </div>
<!--
              <b-input-group class="mb-4">
                        <div class="text-danger" v-if="this.changePasswordErrorMessage && this.changePasswordErrorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.changePasswordErrorMessage }}</div>
              </b-input-group>
-->
          </b-form>
      

          <div slot="footer" class="text-right">
            <b-button variant="primary" @click="sendTestMail()"><i class="fa fa-envelope-o"></i> Enviar E-mail de Teste</b-button>
          </div>
          
        </b-card>

      </b-modal>


  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch
  },
  data: () => {
    return {
      testModal: false,
      changePasswordErrorMessage: '',
      passwordModal: false,
      password: '',
      password2: '',

      testMailResponse: "",
      testMail: {
      },
    
      statusddl: [
        {
          text: '- Todos -',
          value: 0
        },
        {
          text: 'Ativo',
          value: 'A'
        },
        {
          text: 'Inativo',
          value: 'I'
        }
      ],

      mailServerDDL: [],
      companyDDL: [],
      isBusy: false,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      filters: {
        companyId: 0,
        status: 0,
        key: ''
      },

      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",

      selectedItem: newItem,
      items: [        
      ],
      fields: [
        //{key: 'show_details', label: "", thStyle: { width: "100px" } },
        //{key: 'id' },
        {key: 'mailServer.name', label: 'Servidor', sortable: true, thStyle: { width: "400px" } },
        {key: 'name', label: 'Conta de E-mail', sortable: true, thStyle: { width: "400px" } },
        {key: 'username', label: 'Usuário', sortable: true },
        //{key: 'authenabled', label: 'Autenticação', sortable: true, thStyle: { width: "40px" } },
        //{key: 'sslenabled', label: 'SSL', sortable: true, thStyle: { width: "40px" } },
        //{key: 'tlsenabled', label: 'TLS', sortable: true, thStyle: { width: "40px" } },
        {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } },
        {key: 'action', label: '', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle', class: 'text-center' }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    totalRows: function () { return this.getRowCount() },
    filteredItems() {
      try {
        return this.items.filter(item => {
              return (this.filters.key == '' || (
                  this.$utils.filterString(item.name, this.filters.key)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                  
            })
      }
      catch(e) {
          return this.items;
      }
    }
  },
  methods: {

    async changePasswordSubmit() {
        var s = this;
        var userData = this.changePasswordItem
       
        userData.password = this.password,
        userData.uid = this.$store.state.currentUser.id,
        userData.sid = this.$store.state.currentUser.sid
        
        await axios.post(
            this.$store.state.ws_url + "/sys/mail/account/changepassword",
            userData
        ).then( function(resp) {
            
            toast ({
              type: VueNotifications.types.success,
              title: 'Conta de e-amil',
              message: 'Senha alterada com sucesso',
              timeout: 5000
            })
            s.password = ''
            s.password2 = ''
            s.passwordModal = false
          }
        ).catch(function (error) {
          console.log(error)
          toast ({
            type: VueNotifications.types.error,
            title: 'Conta de e-mail',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
      

    },

    changePassword() {
      if(this.password.length < 3 || this.password2.length < 3) {
        this.changePasswordErrorMessage = "Entre com a senha e confirmar senha."
      }
      else
      if(this.password != this.password2) {
        this.changePasswordErrorMessage = 'Nova senha e Confirmar senha diferentes. Por favor verifique e tente novamente.'
      }
      else {
        this.changePasswordErrorMessage = "Enviando solicitação. Aguarde..."
        this.changePasswordSubmit();
      }
    },

    changePasswordModal(item) {
      this.changePasswordItem = item
      this.password = ''
      this.password2 = ''
      this.passwordModal = true;
    },

    getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
    
    changeStatus(item) {
      if(item != null) {
        if(item.st == 'A') 
          item.st = 'I'; 
        else 
          item.st = 'A';
        this.saveItem(item);
      }
    },

    async postTestMail() {

      var s = this;
      var postData = {...this.testMail};
      postData["mailAccountId"] = this.selectedItem.id
      postData["uid"] = this.$store.state.currentUser.id
      postData["sid"] = this.$store.state.currentUser.sid
      s.testMailResponse = new Date().toISOString() + " - Enviando e-mail, aguarde..."

      await axios.post(
          this.$store.state.ws_url + "/mail/send",
          postData
      ).then(function() {
          s.testMailResponse += "\r\n" + new Date().toISOString() + " - E-mail enviado com sucesso."
      }
      ).catch(function (error) {
          console.log(error)
          s.testMailResponse += "\r\n" + new Date().toISOString() + " - " + error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.'
      });

    },

    sendTestMail() {
      let msgError = [];

      if(!this.testMail.recipients || this.testMail.recipients.length <= 1)
          msgError.push("Destinatário");
      
      if(!this.testMail.subject || this.testMail.subject.length <= 1)
          msgError.push("Assunto");
      
      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Campos Obrigatórios',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
          this.postTestMail(this.selectedItem);
      }

    },

    async saveItem(currentItem) {
      
      var s = this;
      var postData = {...currentItem};

      postData["companyId"] = s.filters.companyId
      postData["uid"] = this.$store.state.currentUser.id
      postData["sid"] = this.$store.state.currentUser.sid

      await axios.post(
          this.$store.state.ws_url + "/sys/mail/account",
          postData
      ).then(function() {
          s.closeEditModal()
          s.refreshData();
      }
      ).catch(function (error) {
          console.log(error);

          toast ({
              type: VueNotifications.types.warn,
              title: 'Erro',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
          })        
      });
    },

    save() {

      let msgError = [];

      if(!this.selectedItem.mailServerId || this.selectedItem.mailServerId <= 0)
          msgError.push("Servidor de e-mail");
      
      if(!this.selectedItem.name || this.selectedItem.name.length <= 1)
          msgError.push("Conta de e-mail");
      
      if(!this.selectedItem.email || this.selectedItem.email.length <= 1)
          msgError.push("E-mail");
  
      if(!this.selectedItem.username || this.selectedItem.username.length <= 1)
          msgError.push("Usuário");

      if(!this.selectedItem.id && (!this.selectedItem.password || this.selectedItem.password.length <= 1))
          msgError.push("Senha");

      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Erro',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
          this.saveItem(this.selectedItem);
      }
    },

    enableDisable() {
      console.log('Habilitando/desabilitando conta de e-mail')
      console.log(this.selectedItem);
    },

    closeTestModal() {
      this.testModal = false;
    },
    openTestModal(item) {
      this.testModal = true
      this.selectedItem = item
    },

    closeEditModal() {
      this.editModal = false;
    },
    openEditModal(item) {
      if(item == null) {
          this.selectedItem = newItem;      
      }
      else {
          this.selectedItem = JSON.parse(JSON.stringify(item));
      }
      this.editModal = true;
    },
    onRowSelected(items) {
      this.selected = items
      //console.log(items);
      //this.openEditModal(items[0])
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelectedRows() {
      this.$refs.selectableTable.clearSelected();
    },
    rowClicked(item) {
      if(!this.tableSelectable) {
          this.clearSelectedRows();
          this.openEditModal(item);
      }
    },

    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },
    
    toggleBusy() {
      this.isBusy = !this.isBusy
    },

    async getMailServer() {
      var s = this
      var currentUser = this.$store.state.currentUser;
        
      await axios.get(
        this.$store.state.ws_url + "/sys/mail/server/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
        s.mailServerDDL = resp.data.obj;
      }).catch(function(error) {
        console.log(error)
      });
    },

    async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        this.isBusy = true
       
        await axios.get(
          this.$store.state.ws_url + "/sys/mail/account?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.items = resp.data.obj;
        }).catch(function(error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Conta de E-mail',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 3000
          })
        });
        this.isBusy = false;
      
    },
    changeCompany() {
      this.getMailServer()
      this.refreshData()
    }
  },
  mounted: function() {
    this.companyDDL = this.$store.state.currentUser.companies
    this.filters.companyId = this.$store.state.currentUser.companyId
    this.changeCompany();
    
  }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>